"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var BicycleInfoModal = /** @class */ (function (_super) {
    __extends(BicycleInfoModal, _super);
    function BicycleInfoModal(props) {
        return _super.call(this, props) || this;
    }
    BicycleInfoModal.prototype.render = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.props.closeModal });
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { id: "bicyclesInfo", className: "my-2 info-modal", isOpen: this.props.isOpen, toggle: this.props.closeModal },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.props.closeModal, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "d-block mr-3 mb-1 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "info selected icon" }),
                        React.createElement("div", { className: "text-blue-2 font-weight-medium" }, "Bicycles"))),
                React.createElement(reactstrap_1.ModalBody, { className: "d-flex flex-column alert-close-buttons" },
                    React.createElement("p", null, "We provide cover for your bicycles in the home and you'll automatically get cover up to \u00A3350 for bicycles away from the home. This is limited to \u00A3350 per claim."),
                    React.createElement("p", null, "You need to list any bicycles and their accessories worth over \u00A3350.")),
                React.createElement(reactstrap_1.ModalFooter, { className: "d-flex" },
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1", onClick: this.props.closeModal }, "Ok, I understand")))));
    };
    return BicycleInfoModal;
}(React.Component));
exports.default = BicycleInfoModal;
//# sourceMappingURL=BicycleInfoModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/valuableItemWidget/BicycleInfoModal.js
// module id = 3697
// module chunks = 0